import { ReactComponent as IconNoSearch } from 'asserts/icons/ic_area_search_lined.svg';
import { color } from 'asserts/styles/colors';
import { font } from 'asserts/styles/fonts';
import DefaultButton from 'components/button/DefaultButton';
import styled from 'styled-components';

const NoSearchData = () => {
  return (
    <Wrapper>
      <IconNoSearch />
      <h3>검색결과가 없습니다.</h3>
      <p>
        단어의 철자가 정확한지 확인해 보세요. <br />
        한글을 영어로 혹은 영어를 한글로 입력했는지 확인해 보세요. <br />
        검색어의 단어 수를 줄이거나, 보다 일반적인 검색어로 다시 검색해 보세요.
      </p>
      <DefaultButton text="초기화" size="small" type="link" />
    </Wrapper>
  );
};

export default NoSearchData;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  color: ${color.gray500};

  h3 {
    ${font.h3_medium};
  }

  & > p {
    ${font.body_regular};
  }

  button {
    display: flex;
    width: 128px;
    height: 32px;
    padding: 12px;
    justify-content: center;
    align-items: center;
    border-radius: 24px;
    background: ${color.gray500};
    color: ${color.white2};
    ${font.caption2_medium};
  }
`;
